// extracted by mini-css-extract-plugin
module.exports =  {"colorPicker":"colorPicker_rUmXCaKR","color":"color_K61ElVKK"};